import { Directive, HostBinding, Inject, OnDestroy, OnInit } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { BrandConfigService } from './brand-config.service';

@Directive({ selector: '[brandLoginBackground]' })
export class LoginBackgroundDirective implements OnInit, OnDestroy {
  @HostBinding('style.background-image') backgroundImage = 'none';
  @HostBinding('style.background-size') backgroundSize: string;
  @HostBinding('style.background-position') backgroundPosition = 'center';
  @HostBinding('style.background-repeat') backgroundRepeat = 'no-repeat';
  private image: HTMLImageElement;

  constructor(@Inject(DOCUMENT) private document: Document, private branding: BrandConfigService) {}

  ngOnInit(): void {
    const config = this.branding.getLoginBackground();
    this.backgroundSize = config.size;
    if (!config.enabled) {
      return;
    }
    this.backgroundImage = this.cssUrl(config.src);
    const fallback = this.branding.getDefaultLoginBackground().src;
    if (config.src === fallback) {
      return;
    }
    // CSS backgrounds have no error event, so check the same URL using an image.
    this.image = this.document.createElement('img');
    this.image.onload = () => this.ngOnDestroy();
    this.image.onerror = () => {
      this.backgroundImage = this.cssUrl(fallback);
      this.ngOnDestroy();
    };
    this.image.src = config.src;
  }

  ngOnDestroy(): void {
    if (this.image) {
      this.image.onload = null;
      this.image.onerror = null;
      this.image = null;
    }
  }

  private cssUrl(src: string): string {
    return 'url(' + JSON.stringify(src) + ')';
  }
}
